export default __webpack_public_path__ + "static/media/contact-page-background.057d51c3.svg";